import angular from 'angular';

angular.module('cloudX').directive('cxOptionTypeaheadDropdown', function() {
  return {
    restrict: 'E',
    replace: true,
    template:
      '<div class="dropdown" uib-dropdown ng-show="options.length" is-open="ddwOpen">' +
      ' <div class="input-group" >' +
      '     <input type="text" ng-model="selected" uib-typeahead="item as item.label for item in options | filter:$viewValue | orderBy:\'label\' | limitTo:limit " typeahead-min-length="0" typeahead-select-on-blur="selectOnBlur" typeahead-select-on-exact="selectOnExact" typeahead-on-select="onSelect($item)" ng-blur="onBlur()" ng-focus="ddwOpen=false" class="form-control" placeholder="{{placeholder}}" autocomplete="off"/>' +
      '     <span class="input-group-btn">' +
      '         <button class="btn btn-default btn-font-14 dropdown-toggle" uib-dropdown-toggle>' +
      '             <span class="caret"></span>' +
      '         </button>' +
      '     </span>' +
      ' </div>' +
      ' <ul class="dropdown-menu" role="menu" style="max-height:200px;overflow-y:auto">' +
      '     <li ng-repeat="op in options | orderBy:\'label\'" ng-class="{\'selected\':op===selected}">' +
      '         <a href ng-click=onSelect(op)>{{op.label}}</a>' +
      '     </li>' +
      ' </ul>' +
      '</div>',
    require: ['ngModel', 'cxOptionTypeaheadDropdown'],
    link: function(scope, el, attrs, ctrl) {
      if (!ctrl || ctrl.length !== 2) return;
      var ngModel = ctrl[0];
      var controller = ctrl[1];

      scope.option = scope.$eval(attrs.option) || attrs.option || '';
      scope.limit = scope.$eval(attrs.limit) || 10;
      scope.selectOnBlur = angular.isDefined(attrs.selectOnBlur)
        ? scope.$eval(attrs.selectOnBlur) || attrs.selectOnBlur
        : true;
      scope.selectOnExact = angular.isDefined(attrs.selectOnExact)
        ? scope.$eval(attrs.selectOnExact) || attrs.selectOnExact
        : true;

      scope.options = [];

      scope.view2model = function(value) {
        ngModel.$setViewValue(value);
      };

      // when angular detects a change to the model,
      // we update our inner value
      ngModel.$render = function() {
        scope.value = ngModel.$viewValue;
        scope.selected =
          scope.value == null || !scope.options.length
            ? null
            : scope.options.find(function(el) {
                return el.id === scope.value;
              });
      };

      controller.init();
    },
    controller: [
      '$scope',
      '$rootScope',
      '$filter',
      'optionsSvc',
      function($scope, $rootScope, $filter, optionsSvc) {
        $scope.onSelect = function(i) {
          $scope.selected = i;
          $scope.value = i.id;
          $scope.view2model(i.id);
        };
        //Clear textbox if value is not in option list
        $scope.onBlur = function() {
          if ($scope.selected != null && $scope.selected.id != null) return;
          $scope.selected = null;
          $scope.value = null;
          $scope.view2model(null);
        };

        function mapOptions() {
          var options = optionsSvc.getOptions($scope.option);
          $scope.placeholder = $filter('translateList')(null, $scope.option);

          $scope.options = options.map(function(val) {
            return {
              id: val,
              label: $filter('translateList')(val, $scope.option, val),
            };
          });
          $scope.selected =
            $scope.value == null
              ? null
              : $scope.options.find(function(el) {
                  return el.id === $scope.value;
                });
        }

        this.init = function() {
          mapOptions();
        };
        var deregistration = $rootScope.$on('$translateChangeSuccess', mapOptions);
        $scope.$on('$destroy', deregistration);
      },
    ],
  };
});
